import * as React from "react";

import {capitalize} from "inflection";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSelectBar from "../Gen/SelectBar";

import DocumentListControls from "../Document/ListControls";

import { documentDisplayTitle } from "../../src/document_display_title";

interface CategoryDocumentCreateSelectListProps {
  category_id: number;
  documents: ConnectedList<DocumentSnakeModel>;
}

function CategoryDocumentCreateSelectList(props: CategoryDocumentCreateSelectListProps) {
  const {
    category_id,
    documents,
  } = props;

  React.useEffect(() => {
    documents.mountList(`/categories/${category_id}/category_documents/new_batch_list`);
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);

  const handleSubmitButton = React.useCallback(() => {
    if (documents.selected.length === 0) {
      alert("Nothing Selected! You must select at least one case to add.");
      return;
    }

    const data = {documentIds: documents.selected.map((document) => document.id)};

    setIsSubmitLoading(true);

    fetch(`/categories/${category_id}/category_documents/create_batch_list`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response`); }

        return response.json();
      })
      .then(Turbo.visit(`/categories/${category_id}`))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [category_id, documents.selected]);

  return(
    <div>
      <div className="submit-panel">
        <h1>Add Cases To {capitalize(i18n.t("category"))}</h1>
        <GenButton
          name="Add"
          highlighted
          loading={isSubmitLoading}
          onClick={handleSubmitButton}
        />
      </div>
      <GenSelectBar
        {...documents}
        itemType="case(s)"
      />
      <DocumentListControls
        documents={documents}
      />
      <GenListDisplay
        {...documents}
        renderItem={(document) => <span>{documentDisplayTitle(document)}</span>}
      />
      <GenMore
        {...documents}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(CategoryDocumentCreateSelectList, ["documents"]);
